import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const ArrowDownSmallIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeMiterlimit="1.5" {...props}>
        <path d="m821.717 922.823 16.953-12.317 16.953 12.317" fill="none" stroke={color || "currentColor"} strokeWidth="8.02px" transform="translate(18 4) rotate(90) matrix(0 .37386 -.37386 0 347.708 -304.5)"/>
    </svg>
);

export default ArrowDownSmallIcon;